import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=fa5c4592&"
import script from "./snackbar.vue?vue&type=script&lang=js&"
export * from "./snackbar.vue?vue&type=script&lang=js&"
import style0 from "./snackbar.vue?vue&type=style&index=0&id=fa5c4592&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports